import React from 'react';
import { Link as RouterLink, Switch, Route } from 'react-router-dom';
import { Box, Typography } from 'bonfire-kindling';
import { useTranslation, Trans } from 'react-i18next';

export default function OpportunitiesEmpty({ searchKeyword, hasUserChangedFilter }) {
  const { t } = useTranslation();

  const isSearchingOrFiltering = !!(searchKeyword || hasUserChangedFilter);

  return (
    <Box sx={{ margin: 'auto', width: { xs: '80%', sm: '50%' } }}>
      <Switch>
        <Route path="/opportunities/recommended">
          <Box display="flex" alignItems="center" flexDirection="column" textAlign="center">
            {isSearchingOrFiltering ? (
              <Typography variant="h1" component="h3">
                {t('opportunities.empty.no_recommended_search_title')}
              </Typography>
            ) : (
              <>
                <Typography variant="h1" paragraph component="h3">
                  {t('opportunities.empty.no_recommended_title')}
                </Typography>
                <Typography variant="h3" component="h4">
                  {t('opportunities.empty.no_recommended_subtitle')}:
                </Typography>
                <ul style={{ textAlign: 'left', maxWidth: '31rem' }}>
                  <li>
                    <Typography>
                      <Trans i18nKey="opportunities.empty.no_recommended_first_tip">
                        Broaden your
                        <RouterLink to="/settings/commodity-codes">commodity code</RouterLink>,
                        <RouterLink to="/settings/location">location</RouterLink>, or
                        <RouterLink to="/settings/keywords">keyword</RouterLink> criteria.
                      </Trans>
                    </Typography>
                  </li>
                  <li>
                    <Typography>{t('opportunities.empty.no_recommended_second_tip')}</Typography>
                  </li>
                  <li>
                    <Typography>{t('opportunities.empty.no_recommended_third_tip')}</Typography>
                  </li>
                </ul>
              </>
            )}
          </Box>
        </Route>
        <Route path="/opportunities/following">
          <Box textAlign="center">
            <Typography paragraph variant="h1" component="h3">
              {isSearchingOrFiltering
                ? t('opportunities.empty.no_followed_search')
                : t('opportunities.empty.no_followed')}
            </Typography>
            <Typography paragraph variant="body2" component="h4">
              {t('opportunities.empty.expand_followed')}
            </Typography>
          </Box>
        </Route>
        <Route path="/opportunities/all">
          <Box textAlign="center">
            <Typography paragraph variant="h1" component="h3">
              {isSearchingOrFiltering
                ? t('opportunities.empty.no_search_results')
                : t('opportunities.empty.no_results')}
            </Typography>
          </Box>
        </Route>
      </Switch>
    </Box>
  );
}
